import { useSplitEnabled } from '@buffer-mono/features'
import { TemplateSuggestionsCard } from './TemplateSuggestionsCard'
import { useSelectedChannelPostCount } from './useSelectedChannelPostCount'

import styles from './ChannelQueueNotice.module.css'
import { useSelectedChannel } from '~publish/pages/Channel/ChannelContext'

export const ChannelQueueNotice = (): JSX.Element | null => {
  const { isEnabled: showTemplateSuggestions } = useSplitEnabled(
    'geid-template-library-empty-states',
  )
  const numberOfScheduledPosts = useSelectedChannelPostCount()
  const { id: currentChannelId } = useSelectedChannel()
  if (showTemplateSuggestions && numberOfScheduledPosts === 0) {
    return (
      <div className={styles.container}>
        <TemplateSuggestionsCard
          toggle
          cta="publish-singleChannel-queue-suggestions-1"
          preselectChannelId={currentChannelId}
        />
      </div>
    )
  }

  return null
}
